import axios from 'axios';
import { DEFAULT_TENANT_SLUG } from '@/config/singleTenant';

const API = process.env.REACT_APP_BACKEND_URL;

export const selfRegisterApi = {
  options: (slug = DEFAULT_TENANT_SLUG) =>
    axios.get(`${API}/api/tenant/${slug}/register/options`).then((r) => r.data),
  requestOtp: (slug, body) =>
    axios.post(`${API}/api/tenant/${slug}/register/request-otp`, body).then((r) => r.data),
  confirm: (slug, body) =>
    axios.post(`${API}/api/tenant/${slug}/register/confirm`, body).then((r) => r.data),
};
